export default import.meta.ROLLDOWN_FILE_URL_z$dBiW2bcm1feBN$IpljfQ